import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LoginComponent} from './auth/login/login.component';
import {AdminPanelComponent} from './admin-panel/admin-panel.component';
import {DashboardComponent} from './admin-panel/dashboard/dashboard.component';
import {AdminRoutingModule} from "./admin-panel/admin-routing.module";
import {environment} from "../environments/environment";
import {MatInputModule} from "@angular/material/input";
import {MatIconModule} from "@angular/material/icon";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatListModule} from "@angular/material/list";
import {MatMenuModule} from "@angular/material/menu";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatTabsModule} from "@angular/material/tabs";
import {EditorPanelComponent} from './editor-panel/editor-panel.component';
import {EditorRoutingModule} from "./editor-panel/editor-routing.module";
import {NgOptimizedImage} from "@angular/common";
import {TeamsComponent} from './admin-panel/teams/teams.component';
import {LeagueComponent} from './admin-panel/league/league.component';
import {MatTableModule} from "@angular/material/table";
import {CompetitionsComponent} from './admin-panel/competitions/competitions.component';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {UsersComponent} from './admin-panel/users/users.component';
import {MatPaginatorModule} from "@angular/material/paginator";
import {NewsComponent} from './admin-panel/news/news.component';
import {CreateNewsComponent} from './admin-panel/news/create-news/create-news.component';
import {EditNewsComponent} from './admin-panel/news/edit-news/edit-news.component';
import {UserDialogComponent} from './admin-panel/users/user-dialog/user-dialog.component';
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {LeagueDialogComponent} from './admin-panel/league/league-dialog/league-dialog.component';
import {TeamDialogComponent} from './admin-panel/teams/team-dialog/team-dialog.component';
import {CategoriesComponent} from './admin-panel/categories/categories.component';
import {CategoryDialogComponent} from './admin-panel/categories/category-dialog/category-dialog.component';
import {StandingsComponent} from './admin-panel/standings/standings.component';
import {MatGridListModule} from '@angular/material/grid-list';
import {EditorNewsComponent} from './editor-panel/editor-news/editor-news.component';
import {NationalGamesComponent} from './admin-panel/national-games/national-games.component';
import {NationalDialogComponent} from './admin-panel/national-games/national-dialog/national-dialog.component';
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {EditResultComponent} from './admin-panel/national-games/edit-result/edit-result.component';
import {CreateGameComponent} from './admin-panel/national-games/create-game/create-game.component';
import {WeekGamesDialogComponent} from './admin-panel/competitions/week-games-dialog/week-games-dialog.component';
import {VolunteersComponent} from './admin-panel/volunteers/volunteers.component';
import {EditStatusComponent} from './admin-panel/volunteers/edit-status/edit-status.component';
import {CoachApplicationsComponent} from './admin-panel/coach-applications/coach-applications.component';
import {EditCoachStatusComponent} from './admin-panel/coach-applications/edit-coach-status/edit-coach-status.component';
import {CoursesComponent} from './admin-panel/courses/courses.component';
import {CourseDialogComponent} from './admin-panel/courses/course-dialog/course-dialog.component';
import {MatchesComponent} from './admin-panel/matches/matches.component';
import {MatchModalComponent} from './admin-panel/standings/match-modal/match-modal.component';
import {MatCheckboxModule} from "@angular/material/checkbox";
import {EditorEditNewsComponent} from './editor-panel/editor-news/editor-edit-news/editor-edit-news.component';
import {EditorCreateNewsComponent} from './editor-panel/editor-news/editor-create-news/editor-create-news.component';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {TruncatePipe} from './shared/pipes/truncate.pipe';
import {UpdateNewsComponent} from './admin-panel/news/update-news/update-news.component';
import {MediaUploadComponent} from './admin-panel/news/media-upload/media-upload.component';
import {EditGameComponent} from './admin-panel/standings/edit-game/edit-game.component';
import {AuthInterceptor} from "./auth/services/auth.interceptor";
import {ImageCropperComponent} from "ngx-image-cropper";
import {MatTooltipModule} from "@angular/material/tooltip";
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import {MatSnackBar, MatSnackBarModule} from "@angular/material/snack-bar";
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { SecureCodeComponent } from './auth/secure-code/secure-code.component';
import { FfkTvComponent } from './admin-panel/ffk-tv/ffk-tv.component';
import { FfkTvDialogComponent } from './admin-panel/ffk-tv/ffk-tv-dialog/ffk-tv-dialog.component';
import { EditFfkTvDialogComponent } from './admin-panel/ffk-tv/edit-ffk-tv-dialog/edit-ffk-tv-dialog.component';
import {QuillModule} from "ngx-quill";
import {UserProfileComponent} from "./editor-panel/user-profile/user-profile.component";
import {AdminProfileComponent} from "./admin-panel/admin-profile/admin-profile.component";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/locales/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AdminPanelComponent,
    DashboardComponent,
    EditorPanelComponent,
    TeamsComponent,
    LeagueComponent,
    CompetitionsComponent,
    UsersComponent,
    NewsComponent,
    CreateNewsComponent,
    EditNewsComponent,
    UserDialogComponent,
    LeagueDialogComponent,
    TeamDialogComponent,
    CategoriesComponent,
    CategoryDialogComponent,
    StandingsComponent,
    EditorNewsComponent,
    NationalGamesComponent,
    NationalDialogComponent,
    EditResultComponent,
    CreateGameComponent,
    WeekGamesDialogComponent,
    VolunteersComponent,
    EditStatusComponent,
    CoachApplicationsComponent,
    EditCoachStatusComponent,
    CoursesComponent,
    CourseDialogComponent,
    MatchesComponent,
    MatchModalComponent,
    EditorEditNewsComponent,
    EditorCreateNewsComponent,
    TruncatePipe,
    UpdateNewsComponent,
    MediaUploadComponent,
    EditGameComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    SecureCodeComponent,
    FfkTvComponent,
    FfkTvDialogComponent,
    EditFfkTvDialogComponent,
    UserProfileComponent,
    AdminProfileComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AdminRoutingModule,
    EditorRoutingModule,
    MatInputModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatMenuModule,
    MatToolbarModule,
    MatTabsModule,
    NgOptimizedImage,
    MatTableModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatSelectModule,
    MatDialogModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    MatGridListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    ImageCropperComponent,
    MatTooltipModule,
    MatSnackBarModule,
    QuillModule.forRoot(),
  ],
  providers: [
    {provide: 'BASE_URL', useValue: environment.BASE_URL},
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
